module.exports = __webpack_public_path__ + "static/media/realtime.a6796ca1.png";